import { CalculoMargem } from '~/utils/classes/CalculoMargem';
import { SearchProduto } from '../types';

export const calcMargemVenda = (params: {
  product: SearchProduto;
  custoRep: number;
  venda: number;
}): number => {
  const { product, custoRep, venda } = params;

  return CalculoMargem.getValMargemVenda(
    product.tipo_margem,
    custoRep,
    product.val_custo_sem_imposto,
    venda,
    product.val_imposto_debito,
    product.per_desp_op,
  );
};

/**
 * Wrapper para padronizar chamadas do getValSugestaoVenda.
 */
export const calcSugestaoVenda = async (params: {
  product: SearchProduto;
  custoRep: number;
  margem: number;
  precoArredondamento: any[];
}): Promise<number> => {
  const { product, custoRep, margem, precoArredondamento } = params;

  const sug = await CalculoMargem.getValSugestaoVenda(
    custoRep,
    product.val_custo_sem_imposto,
    margem,
    product.per_desp_op,
    product.per_icms_saida,
    product.tipo_margem,
    1,
    product.per_fcp,
    product.per_pis_lj,
    product.per_cofins_lj,
    false,
    precoArredondamento,
  );

  return Number(sug);
};
